export default __webpack_public_path__ + "static/media/kunal-shinde--f0YLss50Bs-unsplash.82a1aada.jpg";